(() => {
  const DESKTOP_FORM_ID = 'XWERnq';
  const MOBILE_FORM_ID = 'R4qKJJ';
  const WELCOME_FORM_IDS = [DESKTOP_FORM_ID, MOBILE_FORM_ID];
  const LEGACY_FORM_ID = 'VyVJDq';
  const COMPANY_ID = 'XycL7U';

  function getWelcomeFormId() {
    // Use one Klaviyo funnel everywhere. The separate mobile fullscreen form can
    // lock the document before its panel renders in Safari/Chrome, leaving the
    // storefront unscrollable with no visible form. XWERnq is responsive and
    // contains the same email -> SMS upgrade flow.
    return DESKTOP_FORM_ID;
  }

  function clearKlaviyoPageLock() {
    document.body.classList.remove('klaviyo-prevent-body-scrolling');
    document.documentElement.classList.remove('klaviyo-prevent-body-scrolling');

    [document.body, document.documentElement].forEach((element) => {
      [
        'overflow',
        'overflow-x',
        'overflow-y',
        'position',
        'width',
        'height',
        'top',
        'right',
        'bottom',
        'left',
        'touch-action',
        'overscroll-behavior',
        'padding-right'
      ].forEach((property) => element.style.removeProperty(property));
    });
  }

  function getFormDialog(form) {
    return form?.closest('[role="dialog"]') || null;
  }

  function getDialogPanel(dialog) {
    return dialog?.querySelector('[data-testid="POPUP"], [data-testid="FULLSCREEN"], [data-testid="modal-form-container"]') || null;
  }

  function isDialogVisible(dialog) {
    if (!dialog || dialog.getAttribute('aria-hidden') === 'true' || dialog.hasAttribute('inert')) return false;
    const styles = window.getComputedStyle(dialog);
    const bounds = dialog.getBoundingClientRect();
    return styles.display !== 'none'
      && styles.visibility !== 'hidden'
      && Number.parseFloat(styles.opacity || '1') > 0.01
      && bounds.width > 0
      && bounds.height > 0;
  }

  function isWelcomeFormVisible(formId) {
    const form = document.querySelector(`form[data-testid="klaviyo-form-${formId}"]`);
    return isDialogVisible(getFormDialog(form));
  }

  function deactivatePopup(popup) {
    if (!popup) return;
    popup.setAttribute('aria-hidden', 'true');
    popup.setAttribute('inert', '');
    popup.style.setProperty('opacity', '0', 'important');
    popup.style.setProperty('visibility', 'hidden', 'important');
    popup.style.setProperty('pointer-events', 'none', 'important');

    const panel = getDialogPanel(popup);
    if (panel) {
      panel.style.setProperty('opacity', '0', 'important');
      panel.style.setProperty('visibility', 'hidden', 'important');
      panel.style.setProperty('pointer-events', 'none', 'important');
    }
  }

  function reopenHiddenWelcomeForm(formId) {
    const form = document.querySelector(`form[data-testid="klaviyo-form-${formId}"]`);
    const popup = getFormDialog(form);
    if (!popup) return false;
    if (isDialogVisible(popup)) return true;

    const panel = getDialogPanel(popup);
    popup.removeAttribute('inert');
    popup.setAttribute('aria-hidden', 'false');
    popup.style.setProperty('animation-name', 'none', 'important');
    popup.style.setProperty('opacity', '1', 'important');
    popup.style.setProperty('visibility', 'visible', 'important');
    popup.style.setProperty('pointer-events', 'auto', 'important');
    if (panel) {
      panel.style.setProperty('animation-name', 'none', 'important');
      panel.style.setProperty('opacity', '1', 'important');
      panel.style.setProperty('visibility', 'visible', 'important');
      panel.style.setProperty('transform', 'none', 'important');
      panel.style.setProperty('pointer-events', 'auto', 'important');
    }
    document.body.classList.add('klaviyo-prevent-body-scrolling');
    return true;
  }

  function openWelcomeForm() {
    releaseStaleKlaviyoScrollLock();
    const formId = getWelcomeFormId();
    const requestToken = `${Date.now()}-${Math.random()}`;
    window.__alessaWelcomeOpenRequest = requestToken;
    if (reopenHiddenWelcomeForm(formId)) return;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
    window.setTimeout(() => {
      if (!isWelcomeFormVisible(formId)) {
        window._klOnsite.push(['openForm', formId]);
      } else {
        reopenHiddenWelcomeForm(formId);
      }
    }, 900);
    window.setTimeout(() => reopenHiddenWelcomeForm(formId), 1800);
    window.setTimeout(() => {
      if (window.__alessaWelcomeOpenRequest === requestToken) reopenHiddenWelcomeForm(formId);
    }, 2600);
    window.setTimeout(() => {
      if (window.__alessaWelcomeOpenRequest !== requestToken || isWelcomeFormVisible(formId)) return;
      // Never leave an invisible Klaviyo overlay trapping the page. A second
      // click can then retry without the customer needing to refresh.
      document.querySelectorAll('[role="dialog"]:has(form[data-testid^="klaviyo-form-"])').forEach(deactivatePopup);
      clearKlaviyoPageLock();
    }, 3200);
  }

  function hideLegacyForm() {
    let removedLegacyPopup = false;
    document.querySelectorAll(`.kl-teaser-${LEGACY_FORM_ID}`).forEach((teaser) => {
      teaser.style.setProperty('display', 'none', 'important');
    });

    document.querySelectorAll(`form[data-testid="klaviyo-form-${LEGACY_FORM_ID}"]`).forEach((form) => {
      const popup = getFormDialog(form) || form.closest('[data-testid="POPUP"], [data-testid="FULLSCREEN"]');
      if (popup) {
        popup.remove();
        removedLegacyPopup = true;
      }
    });
    return removedLegacyPopup;
  }

  function releaseStaleKlaviyoScrollLock() {
    let hasVisiblePopup = false;

    [...document.querySelectorAll('[role="dialog"][aria-label="POPUP Form"], [role="dialog"][aria-label="FULLSCREEN Form"], [role="dialog"]:has(form[data-testid^="klaviyo-form-"])')].forEach((popup) => {
      if (isDialogVisible(popup)) {
        hasVisiblePopup = true;
        return;
      }

      // Klaviyo keeps its full-screen dialog mounted after the close animation.
      // Make the hidden layer click-through so it cannot trap the page beneath it.
      deactivatePopup(popup);
    });

    if (!hasVisiblePopup) clearKlaviyoPageLock();
  }

  function bindKlaviyoScrollUnlock() {
    if (window.__alessaKlaviyoScrollUnlockBound) return;
    window.__alessaKlaviyoScrollUnlockBound = true;
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const close = event.target.closest('.klaviyo-close-form, .alessa-klaviyo-skip, [aria-label*="close" i]');
      if (!close) return;
      const popup = close.closest('[role="dialog"]');
      window.__alessaWelcomeOpenRequest = null;
      const finishClose = () => {
        deactivatePopup(popup);
        clearKlaviyoPageLock();
        releaseStaleKlaviyoScrollLock();
      };
      window.setTimeout(finishClose, 80);
      window.setTimeout(finishClose, 350);
      window.setTimeout(finishClose, 900);
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      window.__alessaWelcomeOpenRequest = null;
      document.querySelectorAll('[role="dialog"][aria-label="POPUP Form"], [role="dialog"][aria-label="FULLSCREEN Form"], [role="dialog"]:has(form[data-testid^="klaviyo-form-"])').forEach(deactivatePopup);
      clearKlaviyoPageLock();
      window.setTimeout(releaseStaleKlaviyoScrollLock, 100);
      window.setTimeout(releaseStaleKlaviyoScrollLock, 500);
    });
  }

  function bindWelcomeTriggers() {
    if (window.__alessaWelcomeTriggersBound) return;
    window.__alessaWelcomeTriggersBound = true;
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const trigger = event.target.closest('[data-klaviyo-open]');
      if (!trigger) return;
      event.preventDefault();
      openWelcomeForm();
    });
  }

  function openAllWinesPanel() {
    if (window.matchMedia('(max-width: 1023px)').matches) {
      const mobileTrigger = document.querySelector('[data-mobile-editorial-open]');
      if (mobileTrigger) {
        document.documentElement.classList.add('all-wines-panel-open');
        mobileTrigger.click();
        return true;
      }
    }

    const desktopMenu = document.querySelector('hover-disclosure.menu__item--editorial');
    if (desktopMenu) {
      document.documentElement.classList.add('all-wines-panel-open');
      desktopMenu.dispatchEvent(new CustomEvent('theme:disclosure:show', { bubbles: false }));
      desktopMenu.setAttribute('aria-expanded', 'true');
      return true;
    }

    return false;
  }

  function bindAllWinesTriggers() {
    if (window.__alessaAllWinesTriggersBound) return;
    window.__alessaAllWinesTriggersBound = true;
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const trigger = event.target.closest('[data-all-wines-open]');
      if (!trigger) return;
      event.preventDefault();
      if (window.location.pathname !== '/') {
        window.location.assign('/#all-wines');
        return;
      }
      if (window.location.hash !== '#all-wines') {
        window.location.hash = 'all-wines';
        return;
      }
      openAllWinesPanel();
    });
  }

  function bindAllWinesUrl() {
    if (window.__alessaAllWinesUrlBound) return;
    window.__alessaAllWinesUrlBound = true;
    const openFromUrl = () => {
      if (window.location.hash.toLowerCase() !== '#all-wines') return;
      window.setTimeout(() => {
        if (!openAllWinesPanel()) window.setTimeout(openAllWinesPanel, 500);
      }, 80);
    };
    window.addEventListener('hashchange', openFromUrl);
    openFromUrl();
  }

  function bindAllWinesScrollGuard() {
    if (window.__alessaAllWinesScrollGuardBound) return;
    window.__alessaAllWinesScrollGuardBound = true;

    document.addEventListener('wheel', (event) => {
      if (!document.documentElement.classList.contains('all-wines-panel-open')) return;
      const panel = document.querySelector('.mobile-editorial-shop__panel--standalone.is-visible')
        || document.querySelector('hover-disclosure.menu__item--editorial .header__dropdown');
      if (!panel || panel.contains(event.target)) return;
      event.preventDefault();
      panel.scrollBy({ top: event.deltaY, left: 0, behavior: 'auto' });
    }, { passive: false });

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      if (!event.target.closest('[data-mobile-editorial-close]')) return;
      document.documentElement.classList.remove('all-wines-panel-open');
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') document.documentElement.classList.remove('all-wines-panel-open');
    });

    document.querySelectorAll('hover-disclosure.menu__item--editorial').forEach((menu) => {
      menu.addEventListener('theme:disclosure:hide', () => {
        document.documentElement.classList.remove('all-wines-panel-open');
      });
    });
  }

  function findOfferText(form, matcher) {
    const elements = [...form.querySelectorAll('h1, h2, h3, p, label, span, div')]
      .filter((element) => matcher.test((element.textContent || '').trim()));
    return elements.sort((first, second) => {
      const firstHeading = /^H[1-3]$/.test(first.tagName) ? 0 : 1;
      const secondHeading = /^H[1-3]$/.test(second.tagName) ? 0 : 1;
      return firstHeading - secondHeading
        || first.children.length - second.children.length
        || first.textContent.length - second.textContent.length;
    })[0];
  }

  function addOfferEyebrow(title, copy) {
    if (!title || title.parentElement?.querySelector(':scope > .alessa-klaviyo-eyebrow')) return;
    const eyebrow = document.createElement('p');
    eyebrow.className = 'alessa-klaviyo-eyebrow';
    eyebrow.textContent = copy;
    title.insertAdjacentElement('beforebegin', eyebrow);
  }

  function decorateOfferStep(form, step) {
    const submit = form.querySelector('button.klaviyo-form-button, button[type="submit"]');

    if (step === 'sms') {
      const title = findOfferText(form, /join sms/i);
      const intro = findOfferText(form, /vip text access|rare drops and events/i);
      const policy = findOfferText(form, /by submitting this form|consent to receive/i);
      const codeText = findOfferText(form, /^sms15$/i);
      const skip = findOfferText(form, /^no thanks/i);
      const phone = form.querySelector('input[type="tel"], input[autocomplete="tel"]');

      if (title) {
        if (title.textContent.trim() !== 'Join SMS & save 15%.') title.textContent = 'Join SMS & save 15%.';
        title.classList.add('alessa-klaviyo-title');
        addOfferEyebrow(title, 'A little extra from Alex');
      }
      if (intro) {
        const introCopy = 'Add your mobile number to upgrade your first-order offer from 10% to 15%, with first access to rare drops and events.';
        if (intro.textContent.trim() !== introCopy) intro.textContent = introCopy;
        intro.classList.add('alessa-klaviyo-body');
        if (!form.querySelector('.alessa-klaviyo-confirmation')) {
          const confirmation = document.createElement('p');
          confirmation.className = 'alessa-klaviyo-confirmation';
          confirmation.textContent = 'Your 10% email offer is already saved.';
          intro.insertAdjacentElement('afterend', confirmation);
        }
      }
      if (policy) {
        policy.classList.add('alessa-klaviyo-policy');
        policy.style.setProperty('font-size', 'clamp(8px, .58vw, 9px)', 'important');
        policy.style.setProperty('line-height', '1.35', 'important');
        policy.style.setProperty('text-align', 'left', 'important');
      }
      if (codeText) {
        let codeBlock = codeText;
        while (codeBlock.parentElement && codeBlock.parentElement !== form
          && codeBlock.parentElement.textContent.trim().toLowerCase() === 'sms15') {
          codeBlock = codeBlock.parentElement;
        }
        codeBlock.classList.add('alessa-klaviyo-code');
      }
      if (phone) phone.placeholder = 'Mobile number';
      if (submit && submit.textContent.trim() !== 'Send me 15% off') submit.textContent = 'Send me 15% off';
      if (skip) {
        if (skip.textContent.trim() !== 'No thanks, keep my 10% email offer') skip.textContent = 'No thanks, keep my 10% email offer';
        skip.classList.add('alessa-klaviyo-skip');
      }
      return;
    }

    if (step === 'birthday') {
      const title = findOfferText(form, /birthday treat/i);
      const intro = findOfferText(form, /enter your birthday|get your treat/i);
      if (title) {
        if (title.textContent.trim() !== 'A birthday treat, just for you.') title.textContent = 'A birthday treat, just for you.';
        title.classList.add('alessa-klaviyo-title');
        addOfferEyebrow(title, 'A little celebration from Alex');
      }
      if (intro) {
        const introCopy = 'Tell us your birthday and Alex will save a little celebration for you.';
        if (intro.textContent.trim() !== introCopy) intro.textContent = introCopy;
        intro.classList.add('alessa-klaviyo-body');
      }
      if (submit && submit.textContent.trim() !== 'Save my birthday treat') submit.textContent = 'Save my birthday treat';
    }
  }

  function decorateMobileEmailStep(form) {
    const title = findOfferText(form, /claim 10% off|take 10% off|get 15% off/i);
    const email = form.querySelector('input[type="email"]');
    const submit = form.querySelector('button.klaviyo-form-button, button[type="submit"]');
    if (title) {
      if (title.textContent.trim() !== 'Get 15% off when you join by SMS.') title.textContent = 'Get 15% off when you join by SMS.';
      title.classList.add('alessa-klaviyo-title');
      addOfferEyebrow(title, 'A welcome pour from Alex');
      if (!form.querySelector('.alessa-klaviyo-mobile-body')) {
        const body = document.createElement('p');
        body.className = 'alessa-klaviyo-body alessa-klaviyo-mobile-body';
        body.textContent = 'Start with your email for 10% off, then add your mobile on the next step to upgrade to 15%.';
        title.insertAdjacentElement('afterend', body);
      }
    }
    if (email && !form.querySelector('.alessa-klaviyo-first-name')) {
      const firstNameRow = document.createElement('div');
      firstNameRow.className = 'alessa-klaviyo-first-name';
      const firstName = document.createElement('input');
      firstName.type = 'text';
      firstName.name = '$first_name';
      firstName.placeholder = 'First name';
      firstName.autocomplete = 'given-name';
      firstName.setAttribute('aria-label', 'First name');
      firstNameRow.appendChild(firstName);
      const emailRow = email.closest('[data-testid="form-row"]') || email.parentElement;
      emailRow?.insertAdjacentElement('beforebegin', firstNameRow);

      const syncFirstName = () => {
        const profileEmail = email.value.trim();
        const profileFirstName = firstName.value.trim();
        if (!profileEmail || !profileFirstName) return;
        window._learnq = window._learnq || [];
        window._learnq.push(['identify', { '$email': profileEmail, '$first_name': profileFirstName }]);
      };
      form.addEventListener('submit', syncFirstName, true);
      submit?.addEventListener('click', syncFirstName, true);
    }
    if (email) email.placeholder = 'Email address';
    if (submit && submit.textContent.trim() !== 'Start & unlock up to 15%') submit.textContent = 'Start & unlock up to 15%';
  }

  function brandWelcomeForm(root) {
    const forms = WELCOME_FORM_IDS.flatMap((formId) => [
      ...document.querySelectorAll(`form[data-testid="klaviyo-form-${formId}"]`)
    ]);

    forms.forEach((form) => {
      const formCopy = form.textContent.toLowerCase();
      const phone = form.querySelector('input[type="tel"], input[autocomplete="tel"]');
      const isBirthday = formCopy.includes('birthday treat') || formCopy.includes('enter your birthday');
      const isSms = !isBirthday && (Boolean(phone) || formCopy.includes('join sms'));
      const step = isBirthday ? 'birthday' : isSms ? 'sms' : 'email';
      const isMobileForm = form.dataset.testid === `klaviyo-form-${MOBILE_FORM_ID}`;
      const isMobileViewport = window.matchMedia('(max-width: 680px)').matches;
      form.dataset.alessaBranded = 'true';
      form.dataset.alessaStep = step;
      if (isMobileForm || isMobileViewport) form.closest('[role="dialog"]')?.classList.add('alessa-mobile-form-dialog');

      let scaleWrapper = form.parentElement;
      for (let level = 0; level < 4; level += 1) scaleWrapper = scaleWrapper?.parentElement || null;
      scaleWrapper?.classList.add('alessa-klaviyo-scale-wrapper');

      let image = form.querySelector('img');
      if (!image && isMobileForm && step !== 'email') {
        const column = form.firstElementChild?.firstElementChild;
        if (column && !column.querySelector('.alessa-klaviyo-injected-image')) {
          const imageWrap = document.createElement('div');
          imageWrap.className = 'alessa-klaviyo-injected-image';
          image = document.createElement('img');
          imageWrap.appendChild(image);
          column.prepend(imageWrap);
        }
      }

      if (image) {
        image.src = step === 'sms'
          ? root.dataset.smsImage
          : step === 'birthday'
            ? root.dataset.birthdayImage
            : root.dataset.emailImage;
        image.alt = step === 'sms'
          ? 'Alex pouring a restaurant-selected red wine from the bar'
          : step === 'birthday'
            ? 'Alex pouring sparkling wine at the restaurant'
            : 'Alex holding one of her personally selected wines';
      }

      if (step !== 'email') {
        decorateOfferStep(form, step);
        return;
      }

      if (isMobileForm) {
        decorateMobileEmailStep(form);
        return;
      }

      const email = form.querySelector('input[type="email"]');
      const paragraphs = form.querySelectorAll('p');
      if (!email || paragraphs.length < 6) return;

      const copy = [
        'A welcome pour from Alex',
        'Get 15% off when you join by SMS.',
        '\u200b',
        'Start with your email for 10% off, then add your mobile on the next step to upgrade to 15%.',
        '\u200b',
        '\u200b'
      ];

      paragraphs.forEach((paragraph, index) => {
        if (copy[index] && paragraph.dataset.alessaCopy !== 'true') {
          paragraph.textContent = copy[index];
          paragraph.dataset.alessaCopy = 'true';
        }
      });
      paragraphs[0]?.classList.add('alessa-klaviyo-eyebrow');
      paragraphs[1]?.classList.add('alessa-klaviyo-title');
      paragraphs[3]?.classList.add('alessa-klaviyo-body');
      if (paragraphs[5]) paragraphs[5].hidden = true;

      const firstName = form.querySelector('input[type="text"]');
      if (firstName) firstName.placeholder = 'First name';
      email.placeholder = 'Email address';
      const submit = form.querySelector('button.klaviyo-form-button');
      if (submit && submit.dataset.alessaCopy !== 'true') {
        submit.textContent = 'Start & unlock up to 15%';
        submit.dataset.alessaCopy = 'true';
      }
    });
  }

  function initialise(root) {
    if (!root || root.dataset.alessaReady === 'true') return;
    root.dataset.alessaReady = 'true';
    bindKlaviyoScrollUnlock();
    bindWelcomeTriggers();
    bindAllWinesTriggers();
    bindAllWinesUrl();
    bindAllWinesScrollGuard();

    if (!document.querySelector(`script[src*="/onsite/js/${COMPANY_ID}/klaviyo.js"]`)) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://static.klaviyo.com/onsite/js/${COMPANY_ID}/klaviyo.js?company_id=${COMPANY_ID}`;
      document.head.appendChild(script);
    }

    const updateForms = () => {
      const removedLegacyPopup = hideLegacyForm();
      brandWelcomeForm(root);
      if (removedLegacyPopup) window.setTimeout(releaseStaleKlaviyoScrollLock, 100);
    };
    updateForms();
    const observer = new MutationObserver(updateForms);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  function initialiseAll() {
    document.querySelectorAll('[data-alessa-site-footer]').forEach(initialise);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  else initialiseAll();
  document.addEventListener('shopify:section:load', initialiseAll);
})();
